<div class="dvb-personal-konfiguration-main">
    <div class="row">
        <div class="col-md-7">
            <dvb-personal-konfiguration konfigurationen="vm.konfigurationen"
                                        new-konfiguration="vm.newKonfiguration">
            </dvb-personal-konfiguration>
        </div>
    </div>
</div>
